import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SharedModule } from '../../ui-components/shared.module';
import { PushPermissionService } from '../../@services/webview/push-permission.service';

/**
 * « Je te préviens la veille d'un gel ? »
 *
 * Posée une fois le premier élément ajouté au jardin, jamais à froid : c'est
 * le moment où une alerte a un sens pour la personne. Refermer la feuille vaut
 * « Plus tard ». Vit au niveau du shell, comme la célébration Premium : elle
 * suit l'utilisateur, pas l'écran d'où il vient.
 */
@Component({
  selector: 'vw-push-permission-toast',
  imports: [SharedModule, TranslatePipe],
  templateUrl: './push-permission-toast.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class PushPermissionToastComponent {
  readonly push = inject(PushPermissionService);
}
